import {
	chariotButtonCss,
	manualButtonCss
} from 'src/components/widget/components/PaymentProcess/DafFlow/styles';
import {
	DafFlowViewProps,
	DafFlowView
} from 'src/components/widget/components/PaymentProcess/DafFlow/types';
import {
	LargePaymentMethodSelect,
	SmallPaymentMethodSelect
} from 'src/components/widget/components/PaymentProcess/PaymentMethodSelect';
import {RedirectNotice} from 'src/components/widget/components/PaymentProcess/RedirectNotice';
import {
	formCss,
	formContainerCss
} from 'src/components/widget/components/PaymentProcess/styles';
import {useConfigContext} from 'src/components/widget/hooks/useConfigContext';

export const ChariotLogo = () => {
	return (
		<svg
			width="101"
			height="16"
			viewBox="0 0 101 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M26.5651 0.257543H29.7622V15.2809H26.5651V0.257543ZM20.2894 15.2809H17.0923V0.257543H20.2894V15.2809ZM26.8019 9.12133H20.0525V6.18104H26.8019V9.12133Z"
				fill="#00203F"
			/>
			<path
				d="M32.2018 15.2809L38.3591 0.257543H41.5168L47.6938 15.2809H44.3389L39.2867 2.01742H40.5497L35.4778 15.2809H32.2018ZM35.2805 12.0616L36.1291 9.4218H43.2337L44.1021 12.0616H35.2805Z"
				fill="#00203F"
			/>
			<path
				d="M50.1138 15.2809V0.257543H56.0936C57.3303 0.257543 58.396 0.479317 59.2907 0.922864C60.1853 1.3521 60.876 1.9745 61.3628 2.79005C61.8496 3.60561 62.093 4.57855 62.093 5.70888C62.093 6.8249 61.8496 7.79069 61.3628 8.60625C60.876 9.40749 60.1853 10.0227 59.2907 10.452C58.396 10.8812 57.3303 11.0958 56.0936 11.0958H51.89L53.3109 9.57203V15.2809H50.1138ZM58.896 15.2809L55.4423 9.82958H58.8565L62.3496 15.2809H58.896ZM53.3109 9.95835L51.89 8.32724H55.916C56.9027 8.32724 57.6395 8.09831 58.1263 7.64046C58.6131 7.16829 58.8565 6.52444 58.8565 5.70888C58.8565 4.87902 58.6131 4.23516 58.1263 3.77731C57.6395 3.31945 56.9027 3.09052 55.916 3.09052H51.89L53.3109 1.43795V9.95835Z"
				fill="#00203F"
			/>
			<path
				d="M65.6128 15.2809V0.257543H68.8099V15.2809H65.6128Z"
				fill="#00203F"
			/>
			<path
				d="M79.7851 15.5385C78.6931 15.5385 77.68 15.3453 76.7459 14.959C75.8249 14.5727 75.0223 14.029 74.3382 13.3279C73.6672 12.6268 73.1409 11.8041 72.7594 10.8598C72.391 9.91543 72.2068 8.88525 72.2068 7.76923C72.2068 6.65321 72.391 5.62303 72.7594 4.67871C73.1409 3.73438 73.6738 2.91167 74.3579 2.21058C75.0421 1.50949 75.8446 0.965787 76.7656 0.579472C77.6866 0.193157 78.6865 0 79.7653 0C80.8573 0 81.8573 0.193157 82.7651 0.579472C83.686 0.965787 84.482 1.50949 85.153 2.21058C85.8372 2.91167 86.37 3.73438 86.7516 4.67871C87.1331 5.60873 87.3239 6.6389 87.3239 7.76923C87.3239 8.88525 87.1331 9.92258 86.7516 10.8812C86.37 11.8255 85.8372 12.6482 85.153 13.3493C84.482 14.0361 83.686 14.5727 82.7651 14.959C81.8573 15.3453 80.8639 15.5385 79.7851 15.5385ZM79.7653 12.5767C80.3837 12.5767 80.9494 12.4622 81.4626 12.2333C81.9888 12.0044 82.4493 11.6753 82.844 11.2461C83.2387 10.8168 83.5413 10.3089 83.7518 9.72227C83.9755 9.13564 84.0873 8.48463 84.0873 7.76923C84.0873 7.05383 83.9755 6.40282 83.7518 5.81619C83.5413 5.22956 83.2387 4.72163 82.844 4.29239C82.4625 3.86315 82.0086 3.53407 81.4823 3.30514C80.956 3.07621 80.3837 2.96175 79.7653 2.96175C79.147 2.96175 78.5747 3.07621 78.0484 3.30514C77.5353 3.53407 77.0814 3.86315 76.6867 4.29239C76.292 4.72163 75.9828 5.22956 75.7591 5.81619C75.5486 6.40282 75.4434 7.05383 75.4434 7.76923C75.4434 8.47032 75.5486 9.12133 75.7591 9.72227C75.9828 10.3089 76.2854 10.8168 76.6669 11.2461C77.0616 11.6753 77.5221 12.0044 78.0484 12.2333C78.5747 12.4622 79.147 12.5767 79.7653 12.5767Z"
				fill="#00203F"
			/>
			<path
				d="M93.3822 15.2809V3.09052H88.9616V0.257543H101V3.09052H96.5793V15.2809H93.3822Z"
				fill="#00203F"
			/>
			<path
				d="M11.272 1.05076C11.3408 1.09302 11.3586 1.18757 11.3108 1.25413L11.2714 1.30881L9.3933 3.92529C9.23593 4.14428 8.9529 4.21268 8.70361 4.12582C8.33005 3.99566 7.93049 3.92529 7.51464 3.92529C7.07982 3.92529 6.66276 4.00231 6.27476 4.14455C4.80885 4.6792 3.75732 6.13699 3.75732 7.85057C3.75732 8.56007 3.9376 9.22572 4.25295 9.80028C4.3821 10.0353 4.53332 10.2551 4.70499 10.4564C5.39274 11.2659 6.39692 11.7764 7.51464 11.7764C7.76228 11.7764 7.87763 12.0838 7.68405 12.2443C7.62823 12.2906 7.57176 12.3361 7.51464 12.3808C6.44696 13.2173 5.15865 13.7627 3.75732 13.9066C3.51247 13.9319 3.26438 13.9448 3.01307 13.9448C2.85686 13.9448 2.70619 13.886 2.58857 13.7791C2.53422 13.7297 2.48053 13.6794 2.42757 13.6283C1.86844 13.0914 1.38787 12.4674 1.00579 11.7759C0.459575 10.7898 0.11301 9.6676 0.0231398 8.47068C0.00807176 8.26604 0 8.05971 0 7.85057C0 6.4209 0.366476 5.08005 1.00579 3.92529C1.34697 3.308 1.76673 2.74523 2.24998 2.24993C2.70094 1.78724 3.2068 1.38302 3.75732 1.05076C4.86267 0.382868 6.1456 9.06616e-06 7.51464 9.06616e-06C7.59482 9.06616e-06 7.67555 0.00113271 7.75519 0.00450591C9.03382 0.0461087 10.2317 0.422222 11.272 1.05076Z"
				fill="#00203F"
			/>
			<path
				d="M13.9754 11.8877C14.023 12.0558 13.8779 12.2145 13.7141 12.1736C13.4931 12.1184 13.3921 12.2143 13.2685 12.4126C13.0274 12.7994 12.5181 13.3956 12.4565 13.4688C10.4382 15.8714 7.16282 15.9162 4.47369 14.9451C4.46298 14.9412 4.45227 14.9373 4.4421 14.9339C4.20547 14.8481 3.98222 14.7612 3.77878 14.6782C3.61643 14.6123 3.46699 14.5489 3.33408 14.4905C3.08673 14.3817 3.12253 14.2895 3.38904 14.3239C3.52288 14.3412 3.65458 14.3525 3.77878 14.3597C4.15457 14.382 4.46549 14.3678 4.56937 14.3616C4.59412 14.3601 4.61885 14.3589 4.64363 14.3582C5.18515 14.3419 5.73401 14.2439 6.27519 14.0581C6.72061 13.9045 7.13605 13.6992 7.51669 13.4503C7.75279 13.2972 7.9755 13.1262 8.18429 12.9412C8.29565 12.8425 8.40219 12.7404 8.50551 12.6339C8.77962 12.3513 9.02535 12.0413 9.23789 11.7105C9.34271 11.5478 9.44004 11.3803 9.52876 11.208C9.5469 11.1728 9.52792 11.1295 9.49058 11.12C9.20779 11.0496 9.10362 10.6878 9.30264 10.4673L10.7012 8.91805L10.7017 8.91751C10.7086 8.90988 11.0638 8.51701 11.1804 8.38764C11.2042 8.36134 11.2303 8.33219 11.2541 8.3059L11.914 7.57461C12.1946 7.26369 12.6939 7.38682 12.8104 7.79567L13.7206 10.9938C13.7212 10.9958 13.7229 10.9972 13.7249 10.9977C13.7277 10.9983 13.7293 11.0014 13.7286 11.0042C13.728 11.0064 13.7275 11.0085 13.727 11.0108C13.7266 11.0126 13.7266 11.0144 13.7271 11.0162L13.9245 11.7099L13.9475 11.7889L13.9754 11.8877Z"
				fill="#00203F"
			/>
			<path
				d="M2.01325 8.96461C0.989941 9.18868 -0.0400886 8.49938 0.00784723 7.41322C0.0537471 6.37318 0.300533 5.3465 0.740811 4.39654C1.45724 2.85074 2.64569 1.59503 4.1207 0.825379C5.5957 0.0557292 7.27427 -0.184559 8.89443 0.142017C9.8901 0.342713 10.8293 0.750556 11.6587 1.33385C12.5249 1.94302 12.4409 3.21363 11.6566 3.93279C10.8722 4.65194 9.66932 4.50639 8.68146 4.14963C8.51643 4.09003 8.34679 4.04245 8.17368 4.00755C7.37463 3.84649 6.54677 3.965 5.81931 4.34458C5.09184 4.72417 4.50571 5.34348 4.15237 6.10585C4.07582 6.27101 4.01114 6.44087 3.95847 6.61407C3.64319 7.65079 3.03655 8.74054 2.01325 8.96461Z"
				fill="#00203F"
			/>
		</svg>
	);
};

export const DafStartView = ({changeView}: DafFlowViewProps) => {
	const {primaryColor} = useConfigContext();

	return (
		<div className={formCss}>
			<LargePaymentMethodSelect />
			<div className={formContainerCss}>
				<SmallPaymentMethodSelect />
				<h4>Instant DAF donation</h4>
				<p>
					We use Chariot to verify your account info and automatically initiate
					a grant from your DAF, or you can get instructions for making the
					donation manually.
				</p>
				<button
					type="button"
					className={chariotButtonCss}
					onClick={() => {
						changeView(DafFlowView.AMOUNT);
					}}
				>
					<span>Donate with</span>
					<ChariotLogo />
				</button>
				<button
					type="button"
					className={manualButtonCss(primaryColor)}
					onClick={() => {
						changeView(DafFlowView.MANUAL);
					}}
				>
					Get instructions for a manual DAF donation
				</button>
				<RedirectNotice />
			</div>
		</div>
	);
};
